import { render } from "./Refresh.vue?vue&type=template&id=029ef08f"
import script from "./Refresh.vue?vue&type=script&lang=js"
export * from "./Refresh.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Refresh.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "029ef08f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('029ef08f', __exports__)) {
    api.reload('029ef08f', __exports__)
  }
  
  module.hot.accept("./Refresh.vue?vue&type=template&id=029ef08f", () => {
    api.rerender('029ef08f', render)
  })

}


export default __exports__